import React, { Component } from "react";
import LoginForm from "./LoginForm";
import * as Business from "../../utils/business";

const LOGIN_CSS_ID = "ey-login-animations";

function injectLoginCSS() {
  if (document.getElementById(LOGIN_CSS_ID)) return;
  const style = document.createElement("style");
  style.id = LOGIN_CSS_ID;
  style.textContent = `
    @keyframes loginEntrance {
      0%   { opacity: 0; transform: translateY(48px) scale(0.96); }
      100% { opacity: 1; transform: translateY(0)    scale(1);    }
    }
    @keyframes loginShake {
      0%,100% { transform: translateX(0); }
      15%     { transform: translateX(-10px); }
      30%     { transform: translateX(10px); }
      45%     { transform: translateX(-7px); }
      60%     { transform: translateX(7px); }
      75%     { transform: translateX(-4px); }
      90%     { transform: translateX(4px); }
    }
    @keyframes loginSuccess {
      0%   { transform: scale(1);    box-shadow: 0 40px 100px rgba(0,0,0,0.55); }
      50%  { transform: scale(1.03); box-shadow: 0 40px 100px rgba(60,200,100,0.35); }
      100% { transform: scale(1);    box-shadow: 0 40px 100px rgba(0,0,0,0.55); }
    }
    @keyframes shimmer {
      0%   { background-position: 200% center; }
      100% { background-position: -200% center; }
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
    @keyframes bgFloat1 {
      0%,100% { transform: translateY(0)   rotate(0deg);   opacity: 0.10; }
      50%     { transform: translateY(-28px) rotate(180deg); opacity: 0.20; }
    }
    @keyframes bgFloat2 {
      0%,100% { transform: translateY(0)  scale(1);   opacity: 0.07; }
      50%     { transform: translateY(22px) scale(1.1); opacity: 0.13; }
    }
    @keyframes bgPulse {
      0%,100% { opacity: 0.04; transform: scale(1);    }
      50%     { opacity: 0.11; transform: scale(1.06); }
    }
    .login-card {
      animation: loginEntrance 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
    }
    .login-card--shake {
      animation: loginShake 0.55s ease both;
    }
    .login-card--success {
      animation: loginSuccess 0.7s ease both;
    }
    .login-submit-btn:not(:disabled):hover {
      transform: translateY(-2px) !important;
      box-shadow: 0 10px 28px rgba(255,230,0,0.55) !important;
    }
    .login-submit-btn:not(:disabled):active {
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      loginError: false,
      loginSuccess: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    injectLoginCSS();
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this),
    );
  }

  updateWindowDimensions() {
    if (this.refs.loginRef) {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
      Business.setSizeScreen(window.innerWidth, window.innerHeight);
    }
  }

  handleSubmit = (values) => {
    this.setState({ loginError: false, loginSuccess: false });
    const result = this.props.onLogin && this.props.onLogin(values);
    if (result && typeof result.then === "function") {
      result
        .then((outcome) => {
          if (outcome && outcome.success) {
            this.setState({ loginSuccess: true });
          } else {
            this.setState({ loginError: true }, () => {
              setTimeout(() => this.setState({ loginError: false }), 650);
            });
          }
        })
        .catch(() => {
          this.setState({ loginError: true }, () => {
            setTimeout(() => this.setState({ loginError: false }), 650);
          });
        });
    }
  };

  render() {
    const { loginError, loginSuccess } = this.state;
    return (
      <div
        ref="loginRef"
        style={{
          background:
            "linear-gradient(150deg, #050C22 0%, #091232 35%, #0E1A45 65%, #0A1535 100%)",
          minHeight: this.state.height || "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Yellow top accent bar */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #FFE600, #F0C000, #FFE600)",
            zIndex: 100,
          }}
        />

        {/* Floating decorative blobs */}
        <div
          style={{
            position: "absolute",
            top: "12%",
            right: "8%",
            width: "360px",
            height: "360px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(255,230,0,0.09) 0%, transparent 70%)",
            animation: "bgFloat1 9s ease-in-out infinite",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "8%",
            left: "4%",
            width: "280px",
            height: "280px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(99,102,241,0.11) 0%, transparent 70%)",
            animation: "bgFloat2 12s ease-in-out infinite",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "42%",
            left: "18%",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(255,230,0,0.06) 0%, transparent 70%)",
            animation: "bgPulse 7s ease-in-out infinite",
            pointerEvents: "none",
          }}
        />

        {/* Dot-grid texture */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)",
            backgroundSize: "32px 32px",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            width: "100%",
            maxWidth: "440px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <LoginForm
            onSubmit={this.handleSubmit}
            loginError={loginError}
            loginSuccess={loginSuccess}
          />
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// src/pages/Login/index.js